import { Component, OnInit, ViewChild } from '@angular/core';
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { ConstantService } from '../../services/constant.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { ApiService } from '../../services/api.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Module, AllCommunityModules, RowNode } from '@ag-grid-community/all-modules';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ImageRendererComponent } from '../../renderer/image-renderer.component';

@Component({
  templateUrl: 'dashboard.component.html'
})
export class DashboardComponent implements OnInit {
  @ViewChild('attachmentModal') public attachmentModal: ModalDirective;

  public gridApi;
  public gridColumnApi;
  public gridOptions;
  public modules: Module[] = AllCommunityModules;
  public context;
  public frameworkComponents;
  public defaultColDef;
  public columnDefs;
  public attendanceColDef;
  public expenseColDef;
  public noAttendUserColDef;
  public permission;
  public rowClassRules;
  public rowSelection;
  public currentTime = moment().format('YYYY-MM-DD HH:mm:ss');

  dt1: '';

  userAccess = {
    type: '',
  };
  fullAccess = ['admin', 'operator'];

  bgColor: string[] = ['bg-success', 'bg-info', 'bg-warning', 'bg-danger', 'bg-success', 'bg-primary'];
  totalEmployee : any = '';

    // barChart
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public barChartLabels: string[] = [];
  public leaveRequestLabel: string[] = [];
  public barChartType = 'bar';
  public barChartLegend = true;

  public barChartData: any[] = [
    {data: [], label: ''},
    {data: [], label: ''},
    {data: [], label: ''}
  ];
  public leaveRequestData: any[] = [
    {data: [], label: ''},
    {data: [], label: ''},
    {data: [], label: ''}
  ];

  // lineChart
  public lineChartData: Array<any> = [
    {data: [], label: ''}
  ];
  public lineChartLabels: Array<any> = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
  public lineChartOptions: any = {
    animation: false,
    responsive: true
  };
  public lineChartColours: Array<any> = [
    { // grey
      backgroundColor: 'rgba(148,159,177,0.2)',
      borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    { // dark grey
      backgroundColor: 'rgba(77,83,96,0.2)',
      borderColor: 'rgba(77,83,96,1)',
      pointBackgroundColor: 'rgba(77,83,96,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,83,96,1)'
    },
    { // grey
      backgroundColor: 'rgba(148,159,177,0.2)',
      borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];
  public lineChartLegend = true;
  public lineChartType = 'line';


  constructor(private constantService: ConstantService, private apiService: ApiService) {
    this.userAccess = {
      type: this.constantService.getCookies().TYPE
    }
    this.frameworkComponents = {
      imageButtonRenderer : ImageRendererComponent,
    };

    this.context = { componentParent: this };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      floatingFilter: false,
      filterParams: { buttons: ['clear'] }
    };
    this.attendanceColDef = [,
      { headerName: 'Employee Id', field: 'employee_id', width: 150 },
      { headerName: 'User Name', field: 'full_name', width: 150 },
      { headerName: 'Location', field: 'location', width: 150 },
      { headerName: 'In Time', field: 'in_time', width: 100, cellRenderer: params => {
        return moment(params.data.in_time).format('HH:mm');}},
      { headerName: 'Address', field: 'in_address', width: 350},
      { headerName: 'Out Time', field: 'out_time', width: 120 , cellRenderer: params => {
        return params.data.out_time == '0000-00-00 00:00:00' || !params.data.out_time ? '' : moment(params.data.out_time).format('HH:mm');}},
      { headerName: 'Address', field: 'out_address', width: 350 }
    ];

    this.expenseColDef = [
      { headerName: 'Date', field: 'exp_date' },
      { headerName: 'User name', field: 'username' },
      { headerName: 'Full Name', field: 'full_name' },
      { headerName: 'Expense Head', field: 'head' },
      { headerName: 'Amount', field: 'amount' },
      { headerName: 'Narration', field: 'narration' },
      { headerName: 'Approved', field: 'approved' },
    ]
    this.expenseColDef.push(
      { headerName: 'Attachment', field: 'value', cellRenderer: 'imageButtonRenderer', colId: 'paramsImg',  width: 100, filter: false, resizable: true, sortable: false,cellClass: ['text-center'],  },
      );


      this.noAttendUserColDef = [
        { headerName: 'Employee Id', field: 'employee_id' },
        { headerName: 'Full Name', field: 'full_name' },
        { headerName: 'Phone Number', field: 'phone_no' },
        { headerName: 'Designation', field: 'designation' },
        { headerName: 'Work Location', field: 'work_location' },
        { headerName: 'Device', field: 'app_device' }
      ]
  }



  ngOnInit(): void {
    this.fetchTodayAttendance();
    this.getCountBySectorAndDept();
    this.getVisitCountMonthly();
    this.getLeaveRequest();

    this.fetchEmployee();
    this.fetchUserNotMakingAttendance();
  }
  todayEnd = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
  todayStart = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");



  todaysAttendace: any = [];
  todaysExpesne: any = [];

  fetchTodayAttendance() {
    let queryString = "attendance.*, project.name as project_name, employees.employee_id as employee_id, employees.full_name as full_name, employees.work_location as location FROM attendance, project, employees WHERE DATE(date) = DATE(CURDATE()) AND attendance.project = project.srl_no AND attendance.username = employees.phone_no ORDER BY attendance.srl_no DESC";
    console.log(queryString);
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      this.todaysAttendace = resp;
      console.log(this.todaysAttendace)
    })
  }
  employeesObj: any = {};
  fetchEmployee(){
    let queryString = " full_name, phone_no from employees";
    console.log(queryString);
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      this.totalEmployee = resp.length;
      _.each(resp, (data: any) => {
        this.employeesObj[data.phone_no] = data.full_name;
      })
      this.fetchTodayExpense();
    })
  }
  fetchTodayExpense() {
    let queryString = "* from expense_manager WHERE DATE(exp_date) = CURDATE()";
    console.log(queryString);
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      this.todaysExpesne = resp;
      _.each(resp, (data: any) => {
        data['full_name'] = this.employeesObj[data.username] ? this.employeesObj[data.username].fullName : '';
      })
      console.log(this.todaysExpesne)
    })
  }
  userNotMakingAttendance:any  = [];
  fetchUserNotMakingAttendance() {
    let queryString = "employees.employee_id, employees.full_name, employees.phone_no, employees.designation, employees.work_location, employees.app_device FROM employees LEFT JOIN attendance a ON employees.phone_no = a.username AND a.date >= DATE_SUB(CURDATE(), INTERVAL 3 DAY) WHERE a.username IS NULL";
    console.log(queryString);
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      this.userNotMakingAttendance = resp;
    })
  }
  onGridReady(params) {

    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  dashboardData: any = [];
  getCountBySectorAndDept() {
    // date > now() - interval 7 day
    this.dashboardData = [];
    let queryString = `COUNT( CASE WHEN out_address IS NOT NULL THEN 1 END ) AS total_out, COUNT( * ) AS total_in, DATE(date) as dt FROM attendance WHERE MONTH(date) = MONTH(CURDATE())  AND YEAR(date) = YEAR(CURDATE())  GROUP BY DATE(date)`;
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      let data = resp;
      let keys = Object.keys(data);
      console.log(data);
      console.log(keys);
      this.barChartLabels = data.map(key => key.dt);
      this.barChartData = [
        {data: data.map(key => key.total_in), label: 'In'},
        {data: data.map(key => key.total_out), label: 'Out'}
        // {data: data.map(key => key.total_in), label: 'Total'}
      ];
    });
  }
  getLeaveRequest() {
    // date > now() - interval 7 day
    this.dashboardData = [];
    let queryString = `COUNT( CASE WHEN status LIKE 'Approved' THEN 1 END ) AS Approved, COUNT( CASE WHEN status LIKE 'Pending' THEN 1 END ) AS Pending, COUNT( * ) AS total, DATE(date) as dt FROM leave_manager WHERE MONTH(date) = MONTH(CURDATE())  AND YEAR(date) = YEAR(CURDATE())   GROUP BY DATE(date)`;
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      let data = resp;
      let keys = Object.keys(data);
      console.log(data);
      console.log(keys);
      this.leaveRequestLabel = data.map(key => key.dt);
      this.leaveRequestData = [
        {data: data.map(key => key.Approved), label: 'Approved'},
        {data: data.map(key => key.Pending), label: 'Pending'},
        {data: data.map(key => key.total), label: 'Total'}
      ];
    });
  }
  getVisitCountMonthly() {
    // date > now() - interval 7 day
    this.dashboardData = [];
    let queryString = `COUNT(*) as count , DATE(date) as dt FROM visit_report WHERE MONTH(date) = MONTH(CURDATE()) AND YEAR(date) = YEAR(CURDATE())  GROUP BY DATE(date)`;
    console.log(queryString)
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      let data = resp;
      let keys = Object.keys(data);
      console.log(data);
      console.log(keys);
      this.lineChartLabels = data.map(key => key.dt);
      this.lineChartData = [
        {data: data.map(key => key.count), label: 'Total Visit'}
      ];
    });
  }



  selectedData: any = {};
  methodFromParent(userData) {
    this.selectedData = userData;
    console.log(this.selectedData, userData.action);
    if(userData.action === 'image') {
      this.attachmentModal.show();
    }


  }


  // events
  public chartClicked(e: any): void {
    // console.log(e);
  }

  public chartHovered(e: any): void {
    // console.log(e);
  }


}
